<template>
	<div class="routerBox" >
		<transition name="fade-transform" mode="out-in">
			<keep-alive>
				<router-view />
			</keep-alive>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'AppMain',
	components: {},
};
</script>

<style lang="scss" scoped>
.routerBox{width: 100%;}
</style>



// WEBPACK FOOTER //
// src/layout/components/AppMain.vue